import { render, staticRenderFns } from "./addDailySpecialGoods.vue?vue&type=template&id=1d3adfc2&scoped=true&"
import script from "./addDailySpecialGoods.vue?vue&type=script&lang=js&"
export * from "./addDailySpecialGoods.vue?vue&type=script&lang=js&"
import style0 from "./addDailySpecialGoods.vue?vue&type=style&index=0&id=1d3adfc2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3adfc2",
  null
  
)

export default component.exports